import './StatTiles.css';

const nf = new Intl.NumberFormat('en-GB');
const fmt = (v) =>
	v === null || v === undefined || v === '' ? '—' : typeof v === 'number' ? nf.format(v) : v;

export function StatTile({ label, value, tone, variant }) {
	return (
		<div className="stat-tile" data-tone={tone || undefined} data-variant={variant || undefined}>
			<span className={`stat-tile__value${variant === 'text' ? '' : ' numeric'}`}>
				{fmt(value)}
			</span>
			<span className="stat-tile__label">{label}</span>
		</div>
	);
}

export function StatGrid({ children, label }) {
	return (
		<section className="stat-grid" aria-label={label}>
			{children}
		</section>
	);
}

/*
 * Replaces the four fixed `col-2` rows in manager.html:42-110. The old
 * layout produced four cramped tiles per row at every viewport; this one
 * reflows from two columns on a phone up to as many as fit.
 */
/*
 * `chips` is passed explicitly because the two endpoints disagree:
 * /api/manager returns the display shape under `chips`, while /api/archive
 * returns it under `chip_stats` and uses `chips` for the raw FPL array.
 * Guessing from the payload would silently render the wrong one.
 */
export default function StatTiles({ data, chips }) {
	if (!data) return null;

	return (
		<div className="stat-tiles">
			<StatGrid label="Season bests">
				<StatTile label="Best OR" value={data.best_or?.[0]} />
				<StatTile label="Best GW rank" value={data.best_rank?.[0]} />
				<StatTile label="Best points" value={data.best_points?.[0]} />
				<StatTile label="Captain points" value={data.captain_scores_total} />
				<StatTile label="Mean GW rank" value={data.mean_rank} />
				<StatTile label="Median GW rank" value={data.median_rank} />
				<StatTile label="Hits" value={data.hits} />
				<StatTile label="Season ITG" value={data.season_itg} />
			</StatGrid>

			{data.pos_transfers?.length > 0 && (
				<StatGrid label="Transfers by position">
					{data.pos_transfers.map(([position, count]) => (
						<StatTile key={position} label={`${position} transfers`} value={count} />
					))}
				</StatGrid>
			)}

			{chips?.length > 0 && (
				<StatGrid label="Chips">
					{chips.map((chip) => (
						<StatTile
							key={chip.chip}
							label={chip.chip}
							value={chip.label}
							tone="accent"
							variant="text"
						/>
					))}
				</StatGrid>
			)}
		</div>
	);
}
